export const isNil = (value) => value == null;
